export const pageTitle = (
  shortTitle: string,
  longTitle: string,
  description: string
) => {
  document.title = shortTitle
  document
    .querySelector('meta[name="longTitle"]')
    ?.setAttribute('content', longTitle)
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute('content', description)
}
export default pageTitle
